import React, { useEffect, useState } from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

/**
 * Modal for setting (or clearing) an expiry date on one or more SDS files.
 * `initialExpiry` is an ISO date string ("YYYY-MM-DD") or null.
 *
 * Kept as a separate component from the file-manager copy so SDS can
 * iterate on copy / validation rules independently.
 */
const SDSSetExpiryModal = ({
  visible,
  initialExpiry = null,
  onCancel,
  onConfirm,
  confirmLoading = false,
  fileCount = 1,
}) => {
  const [date, setDate] = useState(initialExpiry ? moment(initialExpiry) : null);

  useEffect(() => {
    if (visible) {
      setDate(initialExpiry ? moment(initialExpiry) : null);
    }
  }, [visible, initialExpiry]);

  const handleOk = () => {
    onConfirm(date ? date.format("YYYY-MM-DD") : null);
  };

  return (
    <Modal
      title={
        fileCount > 1
          ? `Set expiry on ${fileCount} files`
          : "Set expiry date"
      }
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save"
      confirmLoading={confirmLoading}
      destroyOnClose
      zIndex={1200}
      wrapClassName="sds-bulk-modal"
    >
      <DatePicker
        style={{ width: "100%" }}
        value={date}
        onChange={(value) => setDate(value)}
        placeholder="Select expiry date"
        // Display in AU DD/MM/YYYY; wire format stays ISO YYYY-MM-DD via
        // handleOk → date.format("YYYY-MM-DD") so the backend stays
        // locale-agnostic.
        format="DD/MM/YYYY"
        getPopupContainer={(trigger) => trigger.parentNode}
      />
      <div style={{ marginTop: 12, fontSize: 12, color: "#888" }}>
        Leave empty to remove the expiry date.
      </div>
    </Modal>
  );
};

export default SDSSetExpiryModal;
